export interface Attempt { attemptId: string; policyRevision: string; documentCaseId?: string }
export interface SavedAttempts { check?: Attempt; settlement?: Attempt; cancel?: Attempt }

/** Only opaque attempt IDs and public correlation are stored. Answers and credentials stay out of browser storage. */
export const attemptStore = (tenantId: string, token: string) => {
    const key = `billing-policy-attempts:${encodeURIComponent(tenantId)}:${encodeURIComponent(token)}`;
    const read = (): SavedAttempts => {
        const raw = localStorage.getItem(key);
        if (!raw) return {};
        const value = JSON.parse(raw);
        if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).some((name) => !['check', 'settlement', 'cancel'].includes(name))) throw new Error('ATTEMPT_STORAGE_INVALID');
        for (const attempt of Object.values(value) as Attempt[]) {
            if (!attempt || typeof attempt !== 'object' || Array.isArray(attempt)
                || Object.keys(attempt).some((name) => !['attemptId', 'policyRevision', 'documentCaseId'].includes(name))
                || typeof attempt.attemptId !== 'string' || !attempt.attemptId || typeof attempt.policyRevision !== 'string' || !attempt.policyRevision
                || (attempt.documentCaseId !== undefined && typeof attempt.documentCaseId !== 'string')) throw new Error('ATTEMPT_STORAGE_INVALID');
        }
        return value;
    };
    return {
        read,
        save: (kind: keyof SavedAttempts, attempt: Attempt) => {
            const { attemptId, policyRevision, documentCaseId } = attempt;
            localStorage.setItem(key, JSON.stringify({ ...read(), [kind]: { attemptId, policyRevision, ...(documentCaseId ? { documentCaseId } : {}) } }));
        },
        remove: (kind: keyof SavedAttempts, attemptId: string) => {
            const saved = read();
            if (saved[kind]?.attemptId !== attemptId) return;
            delete saved[kind];
            localStorage.setItem(key, JSON.stringify(saved));
        },
        clear: () => localStorage.removeItem(key),
    };
};
